import { useState } from "react";
import styled from "styled-components/macro";
import { SwiperSlide } from "swiper/react";
import { Swiper } from "swiper/types";
import { ProductCardType } from "../../../../hooks/api/queries/useProducts";
import { MobileOnly } from "../../../layout/nav/Nav";
import { Carousel } from "../../../ui/carousel/Carousel";
import { ProductCard } from "../../category/ProductCard";

interface Props {
  items: ProductCardType[];
}

export const HomeMobileProductCarousel = ({ items }: Props) => {
  const [, setSwiper] = useState<Swiper>();
  return (
    <MobileOnly>
      <FullWidth>
        <Carousel
          setSwiper={setSwiper}
          slidesPerView={"auto"}
          spaceBetween={10}
          slidesOffsetBefore={15}
        >
          {items.map((item, key) => (
            <SwiperSlide style={{ width: "84.375%" }} key={key}>
              <ProductCard product={item} />
            </SwiperSlide>
          ))}
        </Carousel>
      </FullWidth>
    </MobileOnly>
  );
};

const FullWidth = styled.div`
  width: var(--viewportWidth);
  margin-left: 50%;
  transform: translateX(-50%);
  margin-bottom: 1.25rem;
`;
